import { API_BASE_URL } from '../config/apiConfig';
import type { SupplierQuotation } from '../modules/supplies/supplier-quotations/useData';

function parseErrorMessage(data: unknown): string {
  if (data && typeof data === 'object') {
    const m = (data as { message?: unknown }).message;
    if (typeof m === 'string') return m;
    if (Array.isArray(m)) return m.filter((x) => typeof x === 'string').join(' ');
  }
  return 'Request failed';
}

export interface PublicRfqCurrencyOption {
  id: number;
  code: string;
  name: string;
}

export interface PublicRfqUnitOption {
  id: number;
  ucode?: string | null;
}

export interface PublicRfqVerifyResponse {
  currencies: PublicRfqCurrencyOption[];
  units: PublicRfqUnitOption[];
  quotation: SupplierQuotation;
}

export async function verifyPublicRfq(token: string, pin: string): Promise<PublicRfqVerifyResponse> {
  const res = await fetch(`${API_BASE_URL}/public/rfq/${encodeURIComponent(token)}/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ pin }),
    credentials: 'omit',
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(parseErrorMessage(data));
  }
  return data as PublicRfqVerifyResponse;
}

/** PATCH payload shape matches UpdateSupplierQuotationDto (nested under quotation in API body). */
export type PublicQuotationPatch = Record<string, unknown>;

export async function savePublicRfqDraft(
  token: string,
  pin: string,
  quotation: PublicQuotationPatch,
): Promise<SupplierQuotation> {
  const res = await fetch(`${API_BASE_URL}/public/rfq/${encodeURIComponent(token)}/draft`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ pin, quotation }),
    credentials: 'omit',
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(parseErrorMessage(data));
  }
  return data as SupplierQuotation;
}

export async function submitPublicRfqOffer(
  token: string,
  pin: string,
  quotation: PublicQuotationPatch,
): Promise<SupplierQuotation> {
  const res = await fetch(`${API_BASE_URL}/public/rfq/${encodeURIComponent(token)}/submit-offer`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ pin, quotation }),
    credentials: 'omit',
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(parseErrorMessage(data));
  }
  return data as SupplierQuotation;
}
